import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor(private readonly apiService: ApiService) {}

  getCurrentDayCurrencies(date: Date): Observable<any[]> {
    return this.apiService.post<any>('currency/get-currencies-by-date', {
      date,
    });
  }

   getRateByDateAndExchangeType(dovizCinsiCode:string,date: Date): Observable<any[]> {
    return this.apiService.post<any>('currency/get-currencies-by', {
      date,
      dovizCinsi:dovizCinsiCode
    });
  }

  saveCurrenciesTodDb = () => {
    return this.apiService.get<any>('currency/save-currency-list');
  };
}
